export const siteName = 'CE Dashboard';
export const getPageTitle = (pageName: string) => `${siteName} - ${pageName}`;
